import type { StyleRule } from '@archipro-design/aria';
import { ShopCheckboxFilter } from '@modules/category/component/category-filter-section/CategoryFilterSection.style';

export const MobileProfileNavigation: StyleRule = () => ({
    width: '100%',

    [`& .shopCheckbox`]: {
        ...ShopCheckboxFilter(),
        borderRadius: 0,
    },
});
